export default  {"src":"/_next/static/image/public/assets/icons/no-circle.a36b1030f9d3534caad3d48d3bd410a3.svg","height":25,"width":25};